import getPopularPosts from './getPopularPosts';

/** Populate Popular Now Block with Parsley Data*/
getPopularPosts()
    .then( response => {
        if( !response ) return;
        const popularPosts = response.data;
        document.querySelectorAll('.callout-list.js-parsely').forEach(function(element){
            element.querySelectorAll( 'li' ).forEach(function(el, index){
                el.innerHTML = `<a href="${popularPosts[index].url}">${popularPosts[index].title}</a>`;
            });
        });
    });
